import { InputAdornment } from '@material-ui/core'
import InputNumber from 'components/inputes/InputNumber'
import React, { useState } from 'react'
import { Translate } from 'react-localize-redux'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import PropTypes from 'prop-types'

const InputPlayingMinutes = ({
  initialValue,
  onChangePlayerTime,
  matchPlayerUuid,
}) => {
  const [playingMinutes, setPlayingMinutes] = useState(initialValue)

  const handleChange = (e) => {
    // Update the local state with the new value
    setPlayingMinutes(e.target.value)
  }

  const handleBlur = (e) => {
    // Call the onChangePlayerTime function when the input loses focus
    onChangePlayerTime(e, matchPlayerUuid)
  }

  return (
    <InputNumber
      minLimit={0}
      label={<Translate id="matches.minutes-played" />}
      value={playingMinutes}
      onChange={handleChange}
      onBlur={handleBlur}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <AccessTimeIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
    />
  )
}
InputPlayingMinutes.propTypes = {
  initialValue: PropTypes.number.isRequired,
  matchPlayerUuid: PropTypes.string.isRequired,
  onChangePlayerTime: PropTypes.func.isRequired,
}
export default InputPlayingMinutes
